import { updateRoofInfo } from "../../../Features/roofInfo";
import {
  updateQuantityInfo,
  updateRoofDetails,
} from "../../../Features/quantityInfo";
import { panelInformation } from "../../DataFiles/panelInformation";
import { updateDesignParameter } from "../../../Features/designParameter";
import { PolygonCoordinates, AbstaclesPoint } from "../../../Features/roofInfo";
import { handleStructureClick } from "./structurePlacementFunction/structureCallFunction";
import { roofStructureData } from "./structureFunction";
import { handlePanelRotation, takeScreenshot } from "./canvasFunction";
import { updateGridInfo } from "../../../Features/gridViewInfo";
import {
  handleCustomizedPanelRotation,
  handleCustomizePlacement,
} from "./structurePlacementFunction/customizeStructurePlacement";
import {
  handleMultiPlace,
  SmithFlatPanelRotation,
} from "./structurePlacementFunction/smithStructure";

export const handleCustomizeStructure = (
  value,
  dispatch,
  roofIndex,
  roofDetail
) => {
  const change = value === "smith" ? false : true;
  if (change) {
    dispatch(
      updateRoofDetails({
        index: roofIndex,
        fields: {
          images: [],
          customizeStructure: change,
          orientation: "Landscape",
          moduleSpacing: 25,
          frameSpacing: 25,
          tiltAngle: 15,
          frontHeight: 0,
          blockRow: 1,
          blockCol: 1,
          walkWayCol: 5,
          walkWayType: "Without",
        },
      })
    );
  } else {
    dispatch(
      updateRoofDetails({
        index: roofIndex,
        fields: {
          images: [],
          customizeStructure: change,
          walkWayType: "Without",
        },
      })
    );
  }
};

export const handleUpdateOrientation = (
  item,
  setShowOrientation,
  dispatch,
  index,
  roofInfo,
  gridInfo,
  quantityInfo,
  roofData,
  designParameter
) => {
  setShowOrientation(false);
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        orientation: item.orientation,
      },
    })
  );
  const roofDetail = { ...roofData, orientation: item.orientation };
  handleStructure({
    dispatch,
    roofInfo,
    gridInfo,
    quantityInfo,
    roofDetail,
    designParameter,
  });
};

export const handleDrag = ({ setDrag, dispatch }) => {
  setDrag((prev) => !prev);
  dispatch(
    updateDesignParameter({
      drawPolygon: false,
      drawAbstacle: false,
    })
  );
  dispatch(updateGridInfo({ addStructure: false }));
};

export const handleAddStructure = ({
  gridInfo,
  dispatch,
  roofInformation,
  setDrag,
}) => {
  setDrag(false);
  if (
    roofInformation.mountingStructure === "Select" &&
    !roofInformation.customizeStructure
  ) {
    alert("First of all select a structure type");
  }
  dispatch(updateGridInfo({ addStructure: !gridInfo.addStructure }));
  dispatch(
    updateDesignParameter({
      drawAbstacle: false,
      drawPolygon: false,
    })
  );
};

export const handleNextPage = ({
  dispatch,
  quantityInfo,
  mapRef,
  setLoader,
  navigate,
}) => {
  const roofData = quantityInfo?.roofData || [];

  if (roofData.length > 0) {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      if (
        !(element.buildingHeight >= 0) ||
        !(element.buildingPitch >= 0) ||
        element.module === "Select" ||
        element.moduleType === "Select"
      ) {
        alert(
          `For Roof ${
            i + 1
          }, necessary information is missing on Roof configuration page.`
        );
        setLoader(false);
        return false;
      } else if (element.images.length === 0) {
        alert(`There is no structure placement on Roof ${i + 1}`);
        setLoader(false);
        return false;
      }
    }
    setLoader(true);
    takeScreenshot(mapRef, dispatch);
    setTimeout(() => {
      navigate("/electrical");
    }, 3000);
    return true;
  } else if (roofData.length === 0) {
    setLoader(false);
    alert("Draw the roof and place structures for the roof configuration.");
    return false;
  } else {
    setLoader(true);
    takeScreenshot(mapRef, dispatch);
    setTimeout(() => {
      navigate("/electrical");
    }, 3000);
    return true;
  }
};

export const handleInputChange = (e, dispatch, index) => {
  const value = Number(e.target.value);
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        [e.target.name]: value,
      },
    })
  );
};

export const multipleSelection = (dispatch, index) => {
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        structureType: "Multiple",
        images: [],
      },
    })
  );
};

export const singleSelection = (dispatch, index) => {
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        structureType: "Single",
        images: [],
      },
    })
  );
};

export const handleSearchWattList = (module, setModuleWattList) => {
  const searchModule = module ? module : "Select";

  if (searchModule !== "Select") {
    const moduleData = panelInformation.find(
      (item) => item.brand === searchModule
    );
    if (moduleData && moduleData.panelType) {
      const wattList = moduleData.panelType;
      setModuleWattList(wattList);
    } else {
      const wattList = ["Select"];
      setModuleWattList(wattList);
    }
  } else {
    const wattList = ["Select"];
    setModuleWattList(wattList);
  }
};

export const handleUpdateValue = (
  watt,
  setShowList,
  dispatch,
  index,
  roofDetail
) => {
  let capacity = (roofDetail.pvModule * watt.pMax) / 1000;
  setShowList(false);
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        moduleType: watt.name,
        customCapacity: capacity,
        totalKilowatt: capacity,
      },
    })
  );
};

export const handleUpdateModule = (
  module,
  setShowModuleList,
  dispatch,
  setModuleWattList,
  index
) => {
  setShowModuleList(false);
  handleSearchWattList(module, setModuleWattList);
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        module: module,
        moduleType: "Select",
      },
    })
  );
};

export const handleDeletePolygon = (value, polygon, dispatch, quantityInfo) => {
  dispatch(updateQuantityInfo({ roofNo: 0 }));
  let roofData = quantityInfo.roofData;
  let newArray = [];
  let roofInfoArray = [];
  for (let i = 0; i < polygon.length; i++) {
    if (value !== i) {
      newArray.push(polygon[i]);
      roofInfoArray.push(roofData[i]);
    }
  }
  dispatch(updateRoofInfo({ polygonCoordinates: newArray }));
  dispatch(updateQuantityInfo({ roofData: roofInfoArray }));
};

export const handleDeleteAbstacle = (value, abstacles, dispatch) => {
  dispatch(updateQuantityInfo({ abstacleNo: 0 }));
  let newArray = [];
  for (let i = 0; i < abstacles.length; i++) {
    if (value !== i) {
      newArray.push(abstacles[i]);
    }
  }
  dispatch(updateRoofInfo({ abstacles: newArray }));
};

export const handlePolygon = ({
  setDrag,
  dispatch,
  setPoints,
  designParameter,
}) => {
  setDrag(false);
  setPoints([]);
  dispatch(updateGridInfo({ addStructure: false }));
  dispatch(
    updateDesignParameter({ drawPolygon: !designParameter.drawPolygon })
  );
  dispatch(updateDesignParameter({ drawAbstacle: false }));
};

export const handleAddObstacle = ({
  setDrag,
  setPoints,
  dispatch,
  designParameter,
}) => {
  setDrag(false);
  setPoints([]);
  dispatch(updateGridInfo({ addStructure: false }));
  dispatch(updateDesignParameter({ drawPolygon: false }));
  dispatch(
    updateDesignParameter({ drawAbstacle: !designParameter.drawAbstacle })
  );
};

export const handleRemoveObstacle = (roofInfo, dispatch, setRoofAbstacles) => {
  const abstacles = roofInfo?.value?.abstacles ? roofInfo.value.abstacles : [];
  const newData = [...abstacles];
  newData.pop();
  dispatch(updateRoofInfo({ abstacles: newData }));
  setRoofAbstacles(newData);
};

export const handleMouseDown = ({
  stageRef,
  designParameter,
  points,
  setPoints,
  setCurrentPos,
  cursorDistance,
  dragPos,
  zoomValue,
  dispatch,
  quantityInfo,
}) => {
  let point = stageRef.current.getPointerPosition();
  point = {
    x: (point.x - dragPos.x) / zoomValue,
    y: (point.y - dragPos.y) / zoomValue,
  };
  const updatedPoints = [...points, point];
  let module = "Select";
  let moduleType = "Select";
  const info = quantityInfo.roofData;
  if (info.length > 0) {
    const element = info[0];
    module = element.module;
    moduleType = element.moduleType;
  }

  const roofInfo = {
    structureType: "Single",
    roofType: "Select",
    mountingStructure: "Select",
    module: module,
    moduleType: moduleType,
    images: [],
    buildingHeight: 0,
    buildingPitch: 0,
    totalKilowatt: 0,
    totalStructure: 0,
    customCapacity: 0,
    pvModule: 0,
    endClamp: 0,
    midClamp: 0,
    price: 0,
    railLength: 0,
    walkWayLength: 0,
    beam: 0,
    polls: 0,
    rails: 0,
    azimuth: 180,
    rowDistance: 0,
    sideSpace: 1,
    blockRow: 1,
    blockCol: 1,
    walkWay: 2,
    roadSpace: 3,
    multiStructureRow: 0,
    customCapacityType: "Auto",
    walkWayType: "Without",
    structureFacing: "South Facing",
    customizeStructure: false,
    orientation: "Landscape",
    moduleSpacing: 25,
    frameSpacing: 25,
    tiltAngle: 15,
    frontHeight: 0,
    multipleStructure: [],
    montlyGeneration: [],
    shadingLosses: [],
    actualGeneration: [],
    tiltAngleLosses: [],
    azimuthLosses: [],
    inverterAnalysis: {
      systemType: "On Grid",
      inverterPhase: "Three Phase",
      inverterManufacturer: "Select",
      inverterType: "Select",
      powerSensor: "No Power Sensor",
      communicationDevice: "No Communication Device",
      noOfInverter: 0,
      DCACRatio: 1.2,
      feedMeter: false,
      noOfStringMPPT: 0,
      actualStringMPPT: 0,
      actualString: 0,
      totalStringMPPT: 0,
      lastStringMPPT: 0,
      error: "",
      errorShow: false,
      oneLineMethod: "strings/MPPT",
    },
    financialAnalysis: {
      tpc: 0,
      aeci: 3,
      aetIncrease: 3,
      exportTriff: 10,
      et: 42,
      tcy: 4484,
      jan: 229,
      feb: 143,
      mar: 192,
      apr: 259,
      may: 477,
      jun: 562,
      jul: 732,
      aug: 589,
      sep: 608,
      oct: 313,
      nov: 171,
      dec: 209,
    },
  };

  const roofData = [...info, roofInfo];
  setPoints(updatedPoints);
  if (designParameter.drawPolygon) {
    if (updatedPoints.length > 2) {
      const lastPointToFirstPoint = Math.sqrt(
        Math.pow(cursorDistance.x - updatedPoints[0].x, 2) +
          Math.pow(cursorDistance.y - updatedPoints[0].y, 2)
      );
      if (lastPointToFirstPoint <= 10) {
        updatedPoints.pop();
        dispatch(PolygonCoordinates({ updatedPoints: updatedPoints }));
        setPoints([]);
        dispatch(
          updateDesignParameter({
            drawPolygon: false,
            polygonEdit: true,
            roofAccordion: true,
            customCapacityCheck: false,
          })
        );
        dispatch(updateQuantityInfo({ roofData: roofData }));
        dispatch(updateQuantityInfo({ roofNo: roofData.length - 1 }));
      }
    }
  }
  if (designParameter.drawAbstacle) {
    if (updatedPoints.length >= 3) {
      const lastPointToFirstPoint = Math.sqrt(
        Math.pow(cursorDistance.x - updatedPoints[0].x, 2) +
          Math.pow(cursorDistance.y - updatedPoints[0].y, 2)
      );
      if (lastPointToFirstPoint <= 10) {
        updatedPoints.pop();
        dispatch(AbstaclesPoint({ updatedPoints: updatedPoints }));
        setPoints([]);
        dispatch(
          updateDesignParameter({
            drawAbstacle: false,
            abstacleEdit: true,
            abstacleAccordion: true,
          })
        );
      }
    }
  }
  setCurrentPos(point);
};

export const handleMouseDown2 = (
  e,
  setIsDrawing,
  setStartPos,
  dragPos,
  zoomValue
) => {
  const pos = e.target.getStage().getPointerPosition();
  setIsDrawing(true);
  setStartPos({
    x: pos.x / zoomValue - dragPos.x / zoomValue,
    y: pos.y / zoomValue - dragPos.y / zoomValue,
  });
};

export const handleMouseMove = ({
  designParameter,
  stageRef,
  setCursorDistance,
  dragPos,
  zoomValue,
}) => {
  if (!designParameter.drawPolygon && !designParameter.drawAbstacle) {
    return false;
  }
  let point = stageRef.current.getPointerPosition();
  point = {
    x: (point.x - dragPos.x) / zoomValue,
    y: (point.y - dragPos.y) / zoomValue,
  };
  setCursorDistance(point);
};

export const handleMouseMove2 = (e, setCurrentPos, dragPos, zoomValue) => {
  const pos = e.target.getStage().getPointerPosition();
  setCurrentPos({
    x: pos.x / zoomValue - dragPos.x / zoomValue,
    y: pos.y / zoomValue - dragPos.y / zoomValue,
  });
};

export const handleMouseUp = ({ setCurrentPos }) => {
  setCurrentPos(null);
};

export const handleMouseUp2 = (
  setIsDrawing,
  startPos,
  currentPos,
  quantityInfo,
  setSelectedImage
) => {
  setIsDrawing(false);
  const roofData = quantityInfo?.roofData || [];
  const index = quantityInfo.roofNo;
  let images = [];
  if (roofData.length > 0) {
    images = roofData[index].images;
  }
  if (images && images.length > 0) {
    const selected = images.filter((image) => {
      const minX = Math.min(startPos.x, currentPos.x);
      const maxX = Math.max(startPos.x, currentPos.x);
      const minY = Math.min(startPos.y, currentPos.y);
      const maxY = Math.max(startPos.y, currentPos.y);
      return (
        image.x >= minX &&
        image.y >= minY &&
        image.x + image.width <= maxX &&
        image.y + image.height <= maxY
      );
    });
    setSelectedImage(selected);
  }
};

export const handleRoofType = (item, dispatch, index) => {
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        roofType: item.roofType,
        images: [],
        structureType: "Single",
        mountingStructure: "Select",
        customCapacityType: "Auto",
        walkWayType: "Without",
        newStructure: false,
      },
    })
  );
};

export const handleStructure = ({
  structureItem,
  dispatch,
  roofInfo,
  gridInfo,
  quantityInfo,
  roofDetail,
  designParameter,
}) => {
  if (roofDetail.moduleType === "Select") {
    alert("Please select Module/Panel type first.");
    return false;
  }
  const abstacles = roofInfo?.value?.abstacles ? roofInfo.value.abstacles : [];

  let rowDistance = roofDetail.rowDistance;
  if (!structureItem) {
    structureItem = roofStructureData.find(
      (element) => element.name === roofDetail.mountingStructure
    );
  } else {
    rowDistance = structureItem.gap * 1000;
  }
  if (roofDetail.customizeStructure) {
    if (
      roofDetail.azimuth !== 180 &&
      roofDetail.customCapacityType === "Custom"
    ) {
      handleCustomizedPanelRotation({
        dispatch,
        abstacles,
        roofInfo,
        gridInfo,
        designParameter,
        quantityInfo,
      });
    } else {
      handleCustomizePlacement({
        roofInfo,
        dispatch,
        abstacles,
        roofDetail,
        quantityInfo,
        designParameter,
      });
    }
  } else {
    if (roofDetail.structureType === "Multiple") {
      structureItem = roofStructureData.find(
        (element) => element.name === roofDetail.mountingStructure
      );
      if (!structureItem) {
        alert("please select a structure");
        return false;
      }
      handleMultiPlace({
        structureItem,
        quantityInfo,
        abstacles,
        dispatch,
        roofInfo,
        gridInfo,
      });
    } else {
      if (
        roofDetail.structureType === "Single" &&
        roofDetail.azimuth !== 180 &&
        roofDetail.customCapacityType === "Custom"
      ) {
        if (roofDetail.newStructure) {
          SmithFlatPanelRotation({
            dispatch,
            abstacles,
            roofInfo,
            gridInfo,
            structureItem,
            designParameter,
            quantityInfo,
          });
        } 
        else {
          handlePanelRotation({
            dispatch,
            abstacles,
            roofInfo,
            gridInfo,
            structureItem,
            designParameter,
            quantityInfo,
          });
        }
      } else {
        handleStructureClick({
          structureItem,
          rowDistance,
          roofInfo,
          dispatch,
          abstacles,
          gridInfo,
          roofDetail,
          quantityInfo,
          designParameter,
        });
      }
    }
  }
};

export const handleCapacityType = (value, dispatch, index) => {
  dispatch(
    updateRoofDetails({
      index: index,
      fields: {
        customCapacityType: value,
      },
    })
  );
};

export const handleAzimuthChange = (
  value,
  roofInfo,
  dispatch,
  gridInfo,
  setError,
  roofDetail,
  designParameter,
  quantityInfo
) => {
  if (roofDetail.customCapacityType === "Auto") return false;

  let structureItem = roofStructureData.find(
    (element) => element.name === roofDetail.mountingStructure
  );

  let abstacles = roofInfo?.value?.abstacles || [];
  let azimuth = roofDetail.azimuth;
  let changeAzimuth;
  setError(false);
  if (value === "up" && azimuth > 0 && azimuth < 359) {
    changeAzimuth = azimuth + 1;
    handleAzimuth({
      value,
      roofInfo,
      dispatch,
      gridInfo,
      roofDetail,
      designParameter,
      quantityInfo,
      abstacles,
      changeAzimuth,
      structureItem,
    });
  } else if (value === "down" && azimuth > 1 && azimuth <= 359) {
    changeAzimuth = azimuth - 1;
    handleAzimuth({
      value,
      roofInfo,
      dispatch,
      gridInfo,
      roofDetail,
      designParameter,
      quantityInfo,
      abstacles,
      changeAzimuth,
      structureItem,
    });
  } else {
    setError(true);
  }
};

const handleAzimuth = ({
  value,
  roofInfo,
  dispatch,
  gridInfo,
  roofDetail,
  designParameter,
  quantityInfo,
  abstacles,
  changeAzimuth,
  structureItem,
}) => {
  let rowDistance = roofDetail.rowDistance;
  if (!structureItem) {
    structureItem = roofStructureData.find(
      (element) => element.name === roofDetail.mountingStructure
    );
  } else {
    rowDistance = structureItem.gap * 1000;
  }
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: {
        azimuth: changeAzimuth,
      },
    })
  );
  if (changeAzimuth !== 180) {
    if (roofDetail.customizeStructure) {
      handleCustomizedPanelRotation({
        dispatch,
        abstacles,
        roofInfo,
        gridInfo,
        designParameter,
        quantityInfo,
        value,
        changeAzimuth,
      });
    } else {
      if (roofDetail.newStructure) {
        SmithFlatPanelRotation({
          dispatch,
          abstacles,
          roofInfo,
          gridInfo,
          structureItem,
          designParameter,
          quantityInfo,
          value,
          changeAzimuth,
        });
      } 
      else {
        handlePanelRotation({
          dispatch,
          abstacles,
          roofInfo,
          gridInfo,
          structureItem,
          designParameter,
          quantityInfo,
          value,
        });
      }
    }
  } else {
    if (roofDetail.customizeStructure) {
      handleCustomizePlacement({
        roofInfo,
        dispatch,
        abstacles,
        roofDetail,
        quantityInfo,
        designParameter,
      });
    } else {
      handleStructureClick({
        structureItem,
        rowDistance,
        roofInfo,
        dispatch,
        abstacles,
        gridInfo,
        roofDetail,
        quantityInfo,
        designParameter,
      });
    }
  }
};

export const handleWalkWayType = (value, dispatch, index, roofDetail) => {
  if (
    roofDetail.customCapacityType === "Auto" &&
    !roofDetail.customizeStructure
  ) {
    alert("First of all you need to change the setting from auto to custom ");
    return false;
  } else {
    dispatch(
      updateRoofDetails({
        index: index,
        fields: {
          walkWayType: value,
        },
      })
    );
  }
};
